import styled from "styled-components";
import { theme } from "../../../../theme";
import { SettlementStatusTypes } from "../../../../apis/Settlement/types";
import { CustomTag } from "../../../Tags";
import { TagColors } from "../../../Tags/utils/theme";
import { translateSettlementStatusTypes } from "../../../../shared/constants";

interface Props {
  status: SettlementStatusTypes;
  fee?: number;
}

export default function RepairShopSettlementStatus({ status, fee }: Props) {
  const color: {
    [key in typeof status]: TagColors;
  } = {
    SERVICE_COMPLETED: "yellow",
    SETTLEMENT_REQUESTED: "green",
    SETTLEMENT_CONFIRMED: "primary",
    PAY_COMPLETED: "black",
  };

  return (
    <Container>
      <CustomTag colors={color[status]}>
        {translateSettlementStatusTypes[status]}
      </CustomTag>
      {fee !== undefined && <p>{fee.toLocaleString()}원</p>}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  > p {
    ${theme.typo.heading.b14};
    margin-bottom: 0;
  }
`;
